module.exports = __webpack_public_path__ + "static/media/10.82e4b8ea.jpg";